module.exports = __webpack_public_path__ + "static/media/obiwan.14b017b9.gif";